<!--
 * @Author: zhangjingqing
 * @Date: 2022-02-10 22:54:32
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-19 18:06:00
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\components\GlobalSideMenu.vue
-->
<template>
  <a-layout-sider width="210" v-model="collapsed" collapsible>
<!--    <div class="logo"><img :src="require('@/assets/img/m1.png')" alt="" /></div>-->
    <a-menu
        v-if="menus.length > 0"
        theme="dark"
        mode="inline"
        :selectedKeys="selectedKeys"
        :openKeys="openKeys"
        @openChange="onOpenChange"
        @click="menuClick"
    >
      <template v-for="menu in menus">
        <template v-if="menu.children && menu.children.length > 0">
          <a-sub-menu :key="menu.path">
            <span slot="title">
              <a-icon :type="menu.meta.icon" />
              <span>{{ menu.meta.title }}</span>
            </span>
            <a-menu-item :key="subMenu.path" v-for="subMenu in menu.children">
              {{ subMenu.meta.title }}
            </a-menu-item>
          </a-sub-menu>
        </template>
        <template v-else>
          <a-menu-item :key="menu.path">
            <a-icon :type="menu.meta.icon" />
            <span>{{ menu.meta.title }}</span>
          </a-menu-item>
        </template>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import { adminMap,admin3Map } from "@/router/router.config";
export default {
  name: "GlobalSideMenu",
  data() {
    return {
      collapsed: false,
      menus: "", // 初始化为空数组
      selectedKeys: [],
      openKeys: [""]
    };
  },
  computed: {
    // 从 Vuex store 中获取 userinfo
    userType() {
      return this.$store.getters.userInfo.type
    },

  },

  mounted() {
    this.selectMenu();
    this.updateMenus(this.userType);
  },
  methods: {
    updateMenus(type) {
      if(type ===1){

        this.menus = adminMap[0].children; // 根据 type 获取相应的菜单
      }else if(type === 3){
        // this.menus = admin3Map[0];
        console.log(1)
        this.menus = admin3Map[0].children;
        console.log(this.menus)
      }
    },
    menuClick(menu) {
      this.$router.push({ path: menu.key });
    },
    selectMenu() {
      this.selectedKeys = [];
      let menus = this.menus;
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].children) {
          for (let y = 0; y < menus[i].children.length; y++) {
            if (this.$route.path.indexOf(menus[i].children[y].path) != -1) {
              this.openKeys = [menus[i].path];
            }
          }
        }
      }
      let path;
      let len = this.$route.path.split("/").length;
      if (len > 3) {
        path = this.$route.path.substring(0, this.$route.path.lastIndexOf("/"));
      } else {
        path = this.$route.path;
      }
      this.selectedKeys.push(path);

    },
    onOpenChange(openKeys) {
      if (openKeys.length !== 0) {
        this.openKeys = [openKeys[1]];
      } else {
        this.openKeys = [""];
      }
    },
  },
  watch: {
    $route: function () {
      this.selectMenu();
    },
    userType(newType) {
      this.updateMenus(newType);
    },
  },
};
</script>

<style lang="less" scoped>
.logo {
  height: 30px;
  margin: 17px 15px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
